import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { vovSharedService } from '../../shared/services/vov-shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

    return (invalidCtrl || invalidParent);
  }
}
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  public userId;
  showPassword = false;
  ConfirmshowPassword = false;
  @ViewChild('passwordField') passwordField: ElementRef;
  @ViewChild('ConfirmpasswordField') ConfirmpasswordField: ElementRef;
  matcher = new MyErrorStateMatcher();




  constructor(
    private formBuilder: FormBuilder,
    private vovSharedService: vovSharedService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private activeRouter: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['']
    }, { validator: this.checkPasswords });

    this.activeRouter.params.subscribe(param => {
      console.log(param, 'paramm')
      this.userId = param.id;
      this.vovSharedService.checkisPasswordReset(param.id).subscribe(res => {
        console.log(res, 'resss')
        if (res.message == 'Password Already reset') {
          this.router.navigate(['error-404'])
        }
      })
    })
  }

  checkPasswords(group: FormGroup) {
    let pass = group.controls.password.value;
    let confirmPass = group.controls.confirmPassword.value;
    return pass === confirmPass ? null : { notSame: true }
  }
  onSubmitReset() {
    this.resetPasswordForm.value['userId'] = this.userId;
    console.log(this.resetPasswordForm.value, 'valll')
    this.vovSharedService.resetPassword(this.resetPasswordForm.value).subscribe((res) => {
      if (res && res.message) {
        this._snackBar.open('Success :' + res.message, '', {
          duration: 3000,
          verticalPosition: 'bottom',
          horizontalPosition: 'right',
          panelClass: 'success-snackbar'
        });
        this.router.navigate(['/sign-in']);
      }
    }, error => {
      let errorMessage = error.error.message ? error.error.message : error;
      this._snackBar.open('Error :' + errorMessage, '', {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right',
        panelClass: 'error-snackbar'
      });
    })

  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.passwordField.nativeElement.setAttribute('type', 'text');
    } else {
      this.passwordField.nativeElement.setAttribute('type', 'password');
    }
  }

  toggleConfirmPassword() {
    this.ConfirmshowPassword = !this.ConfirmshowPassword;
    if (this.ConfirmshowPassword) {
      this.ConfirmpasswordField.nativeElement.setAttribute('type', 'text');
    } else {
      this.ConfirmpasswordField.nativeElement.setAttribute('type', 'password');
    }
  }
  goBackToLogin() {
    return this.router.navigate(['/sign-in']);
  }

}
